import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { format, parse } from "date-fns";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
// import TextInput from "../../../../components/hookForms/textField"
import DatePickerMui from "../../../../components/hookForms/datePicker";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import File from "../../../../components/fileInputButton";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
import RadioButton from "../../../../components/hookForms/radioButton";
import { getBase64 } from "../../../../utils/utils";
import messages from "../../../../utils/messages";
import { s3upload } from "../../../../utils/s3";
import serviceFaturaConcessionaria from "../../../../services/serviceFaturaConcessionaria";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import serviceClienteInstalacao from "@/services/serviceClienteInstalacao";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
}

export default function DialogNew({ open, onClose, onSuccess }: IDialogProps) {
    const [fileState, setFileState] = useState(null);
    const [instalacaoDataOptions, setInstalacaoDataOptions] = useState<IGenericResult[]>([]);
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        saldoAtual: yup.string().required(messages.requiredField),
        energiaInjetada: yup.string().required(messages.requiredField),
        consumoKWH: yup.string().required(messages.requiredField),
        instalacaoID: yup.number().required(messages.requiredField).typeError(messages.requiredField),
        valorKWH: yup.string().required(messages.requiredField),
        valorPisEnergiaCompensada: yup.string().required(messages.requiredField),
        taxalluminacaoPublica: yup.string().required(messages.requiredField),
        valorOutrasTaxas: yup.string().required(messages.requiredField),
        disponibilidadeDinheiro: yup.string().required(messages.requiredField),
        disponibilidadeQuantidade: yup.string().required(messages.requiredField),
        valorDeducoes: yup.string().required(messages.requiredField),
        aliquotaICMS: yup.string().required(messages.requiredField),
        aliquotaPIS: yup.string().required(messages.requiredField),
        aliquotaCOFINS: yup.string().required(messages.requiredField),
        valorPISCOFINSCompensado: yup.string().required(messages.requiredField),
        dataLeituraAnterior: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
        dataLeituraAtual: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
        dataProximaLeitura: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
        dataEmissao: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
        dataVencimento: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
        dataReferencia: yup.date().required(messages.requiredField).typeError(messages.invalidDate),
        valorFatura: yup.string().required(messages.requiredField),
        flagDebitoAutomatico: yup.string().required(messages.requiredField),
        possuiCredito: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            saldoAtual: "",
            energiaInjetada: "",
            consumoKWH: "",
            instalacaoID: 0,
            valorKWH: "",
            compensadoSemImpostos: "",
            compensadoComPisCofins: "",
            tarifaSemImpostos: "",
            tarifaComPisCofins: "",
            valorSemImpostos: "",
            valorComPisCofins: "",
            valorPisEnergiaCompensada: "",
            taxalluminacaoPublica: "",
            valorOutrasTaxas: "",
            disponibilidadeDinheiro: "",
            disponibilidadeQuantidade: "",
            valorDeducoes: "",
            aliquotaICMS: "",
            aliquotaPIS: "",
            aliquotaCOFINS: "",
            valorPISCOFINSCompensado: "",
            dataLeituraAnterior: "",
            dataLeituraAtual: "",
            dataProximaLeitura: "",
            dataEmissao: "",
            dataVencimento: "",
            dataReferencia: "",
            valorFatura: "",
            codigoDeBarrasManual: "",
            flagDebitoAutomatico: "Não",
            possuiCredito: "Não",
        },
    });

    const onSubmit = (values: any) => {
        setDisable(true);

        if (validate(values, fileState)) {
            const newItem = {
                ...values,
                saldoAtual: values.saldoAtual ? Number(values.saldoAtual.replaceAll(".", "").replaceAll(",", ".")) : 0,
                energiaInjetada: values.energiaInjetada
                    ? Number(values.energiaInjetada.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                energiaCompensada: values.energiaInjetada
                    ? Number(values.energiaInjetada.replaceAll(".", "").replaceAll(",", "."))
                    : 0, //energiaCompensada = energiaInjetada
                consumoKWH: values.consumoKWH ? Number(values.consumoKWH.replaceAll(".", "").replaceAll(",", ".")) : 0,
                energiaUsada: values.consumoKWH
                    ? Number(values.consumoKWH.replaceAll(".", "").replaceAll(",", "."))
                    : 0, //energiaUsada = consumoKWH
                valorKWH: values.valorKWH ? Number(values.valorKWH.replaceAll(".", "").replaceAll(",", ".")) : 0,
                tarifaKWH: values.valorKWH ? Number(values.valorKWH.replaceAll(".", "").replaceAll(",", ".")) : 0, //tarifaKWH = valorKWH
                compensadoSemImpostos: values.compensadoSemImpostos
                    ? Number(values.compensadoSemImpostos.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                compensadoComPisCofins: values.compensadoComPisCofins
                    ? Number(values.compensadoComPisCofins.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                tarifaSemImpostos: values.tarifaSemImpostos
                    ? Number(values.tarifaSemImpostos.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                tarifaComPisCofins: values.tarifaComPisCofins
                    ? Number(values.tarifaComPisCofins.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                valorSemImpostos: values.valorSemImpostos
                    ? Number(values.valorSemImpostos.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                valorComPisCofins: values.valorComPisCofins
                    ? Number(values.valorComPisCofins.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                valorPisEnergiaCompensada: values.valorPisEnergiaCompensada
                    ? Number(values.valorPisEnergiaCompensada.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                taxalluminacaoPublica: values.taxalluminacaoPublica
                    ? Number(values.taxalluminacaoPublica.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                valorOutrasTaxas: values.valorOutrasTaxas
                    ? Number(values.valorOutrasTaxas.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                disponibilidadeDinheiro: values.disponibilidadeDinheiro
                    ? Number(values.disponibilidadeDinheiro.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                disponibilidadeQuantidade: values.disponibilidadeQuantidade
                    ? Number(values.disponibilidadeQuantidade.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                valorFatura: values.valorFatura
                    ? Number(values.valorFatura.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                valorDeducoes: values.valorDeducoes
                    ? Number(values.valorDeducoes.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                aliquotaICMS: values.aliquotaICMS
                    ? Number(values.aliquotaICMS.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                aliquotaPIS: values.aliquotaPIS
                    ? Number(values.aliquotaPIS.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                aliquotaCOFINS: values.aliquotaCOFINS
                    ? Number(values.aliquotaCOFINS.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                valorPISCOFINSCompensado: values.valorPISCOFINSCompensado
                    ? Number(values.valorPISCOFINSCompensado.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
                dataLeituraAtual: values.dataLeituraAtual ? format(values?.dataLeituraAtual, "yyyy-MM-dd") : "",
                dataEmissao: values.dataEmissao ? format(values?.dataEmissao, "yyyy-MM-dd") : "",
                dataVencimento: values.dataVencimento ? format(values?.dataVencimento, "yyyy-MM-dd") : "",
                dataLeituraAnterior: values.dataLeituraAnterior
                    ? format(values?.dataLeituraAnterior, "yyyy-MM-dd")
                    : "",
                dataProximaLeitura: values.dataProximaLeitura ? format(values?.dataProximaLeitura, "yyyy-MM-dd") : "",
                dataReferencia: values.dataReferencia ? format(values?.dataReferencia, "yyyy-MM-dd") : "",
                cicloFaturamento: values.dataReferencia ? format(values?.dataReferencia, "MM/yyyy") : "",
                flagDebitoAutomatico: values.flagDebitoAutomatico.toLowerCase() === "sim" ? "Sim" : "Não",
                possuiCredito: values.possuiCredito.toLowerCase() === "sim" ? "Sim" : "Não",
            };

            serviceFaturaConcessionaria
                .create(newItem)
                .then((result) => {
                    if (result) {
                        if (fileState) {
                            //Realiza o Upload da Fatura para o S3
                            const bucket = process.env.REACT_APP_S3_BUCKET_FATURAS_CONCESSIONARIA || "";

                            getBase64(fileState).then((base64) => {
                                s3upload(
                                    bucket,
                                    `${
                                        result?.data.numeroInstalacao
                                    }/${result.data.faturaConcessionariaID.toString()}.pdf`,
                                    base64
                                );
                            });
                        }

                        toast.success(messages.createSucess);
                        onClose(true);
                        onSuccess();
                        reset();
                        setFileState(null);
                    }
                })
                .catch((err) => {
                    toast.error(messages.createError, err);
                })
                .finally(() => {
                    setDisable(false);
                });
        } else {
            setDisable(false);
        }
    };

    const handleFileInput = (e: any) => {
        const extension = e.target.files[0].name.split(".").pop().toLowerCase();

        if (["pdf"].includes(extension)) {
            setFileState(e.target.files[0]);
        } else {
            toast.error("O arquivo selecionado é inválido. É necessário anexar a fatura no formato PDF!");
            setFileState(null);
        }
    };

    useEffect(() => {
        setInstalacaoData();
    }, []);

    const setInstalacaoData = async () => {
        serviceClienteInstalacao
            .getAllInstalacoesCliente()
            .then((result) => {
                setInstalacaoDataOptions(result?.data);
            })
            .catch(() => {
                setInstalacaoDataOptions([]);
            });
    };



    const onCancelNew = () => {
        setFileState(null);
        reset();
        onClose(true);
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Nova Fatura de Concessionária
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelNew();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="saldoAtual"
                                label="Saldo"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={24}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="energiaInjetada"
                                label="Injeção"
                                control={control}
                                error={errors}
                                decimalScale={0}
                                maxLength={9}
                                noThousandSeparator
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputNumber
                                name="consumoKWH"
                                label="Consumo"
                                control={control}
                                error={errors}
                                decimalScale={0}
                                maxLength={9}
                                noThousandSeparator
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <AutoComplete
                                name="instalacaoID"
                                label="Instalação"
                                options={instalacaoDataOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="valorKWH"
                                label="Valor kWh"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={27}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="compensadoSemImpostos"
                                label="Compensado Sem Impostos"
                                control={control}
                                error={errors}
                                decimalScale={0}
                                maxLength={10}
                                noThousandSeparator
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="compensadoComPisCofins"
                                label="Compensado Com Pis/Cofins"
                                control={control}
                                error={errors}
                                decimalScale={0}
                                maxLength={9}
                                noThousandSeparator
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="tarifaSemImpostos"
                                label="Tarifa Sem Impostos"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={27}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="tarifaComPisCofins"
                                label="Tarifa Com Pis/Cofins"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={27}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="valorSemImpostos"
                                label="Valor Sem Impostos"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={18}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="valorComPisCofins"
                                label="Valor Com Pis/Cofins"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={19}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="valorPisEnergiaCompensada"
                                label="Pis Cofins"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={27}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="taxalluminacaoPublica"
                                label="Taxa de luz"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={27}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="valorOutrasTaxas"
                                label="Outras taxas"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={27}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="disponibilidadeDinheiro"
                                label="Tarifa de disponibilidade"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={27}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="disponibilidadeQuantidade"
                                label="Quantidade disponível"
                                control={control}
                                error={errors}
                                decimalScale={0}
                                maxLength={19}
                                noThousandSeparator
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="valorDeducoes"
                                label="Deduções"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={23}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="aliquotaICMS"
                                label="Alíquota ICMS"
                                control={control}
                                error={errors}
                                decimalScale={2}
                                maxLength={23}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="aliquotaPIS"
                                label="Alíquota PIS"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={23}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="aliquotaCOFINS"
                                label="Alíquota COFINS"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={23}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="valorPISCOFINSCompensado"
                                label="Valor PIS/COFINS Compensado"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={23}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DatePickerMui
                                name="dataLeituraAnterior"
                                label="Data da Leitura Anterior"
                                control={control}
                                error={errors}
                                noDateForward={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DatePickerMui
                                name="dataLeituraAtual"
                                label="Data da Leitura Atual"
                                control={control}
                                error={errors}
                                noDateForward={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DatePickerMui
                                name="dataProximaLeitura"
                                label="Data da Próxima Leitura"
                                control={control}
                                error={errors}
                                noDateForward={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DatePickerMui
                                name="dataEmissao"
                                label="Data de Emissão"
                                control={control}
                                error={errors}
                                noDateForward={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DatePickerMui
                                name="dataVencimento"
                                label="Data de Vencimento"
                                control={control}
                                error={errors}
                                noDateForward={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DatePickerMui
                                name="dataReferencia"
                                label="Data de Referência"
                                control={control}
                                error={errors}
                                noDateForward={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputNumber
                                name="valorFatura"
                                label="Valor da Fatura"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={23}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputNumber
                                name="codigoDeBarrasManual"
                                label="Código de Barras Manual"
                                noThousandSeparator
                                decimalScale={0}
                                control={control}
                                error={errors}
                                maxLength={100}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RadioButton
                                name="flagDebitoAutomatico"
                                title="Débito Automático"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RadioButton name="possuiCredito" title="Possui Crédito" control={control} error={errors} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <File accept="application/pdf" onChange={handleFileInput} selectedFile={fileState} />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => {
                            onCancelNew();
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

function validate(values: any, selectedFile: any): boolean {
    let dataLeituraAnterior = parse(format(values.dataLeituraAnterior, "dd/MM/yyyy"), "dd/MM/yyyy", new Date());
    let dataLeituraAtual = parse(format(values.dataLeituraAtual, "dd/MM/yyyy"), "dd/MM/yyyy", new Date());
    let dataProximaLeitura = parse(format(values.dataProximaLeitura, "dd/MM/yyyy"), "dd/MM/yyyy", new Date());
    let dataEmissao = parse(format(values.dataEmissao, "dd/MM/yyyy"), "dd/MM/yyyy", new Date());
    let dataVencimento = parse(format(values.dataVencimento, "dd/MM/yyyy"), "dd/MM/yyyy", new Date());

    if (dataLeituraAnterior >= dataLeituraAtual) {
        toast.error("Data leitura atual deve ser maior que a data da leitura anterior.");
        return false;
    }

    if (dataProximaLeitura <= dataLeituraAtual) {
        toast.error("Data da próxima leitura deve ser maior que a data da leitura atual.");
        return false;
    }

    if (dataEmissao <= dataLeituraAtual) {
        toast.error("Data de emissão deve ser maior que a data da leitura atual.");
        return false;
    }

    if (dataVencimento <= dataLeituraAtual) {
        toast.error("Data do vencimento deve ser maior que a data da leitura atual.");
        return false;
    }

    return true;
}
